export class PatientSearchResult {
    public ID = -1;
    public Address = '';
    public Age = 0;
    public CityFull = '';
    public DOBShort = '';
    public DOBdmy = '';
    public DateOfBirth = '';
    public DateOfDeath?: string;
    public EmailAddress = '';
    public FullName = '';
    public InternalNumber = '';
    public Name = '';
    public NationalNumber = '';
    public NationalRegisterNumber?: string;
    public ReferenceNumber = '';
    public Remarks = '';
    public RemarksPrivate = false;
    public Telephone = '';
    public Temporary = false;
}

export class OrderSearchResult {
    public ID = -1;
    public Age = 0;
    public DateOfBirth = '';
    public DateTimeImplementation = '';
    public FullStatus = '';
    public InvoiceAmount = '';
    public InvoiceStatus = '';
    public OrderNumber = '';
    public PatientName = '';
    public Procedures: any[] = [];
    public RequestingPhysician = '';
    public SiteName = '';
    public VisitNumber = '';
}

export interface GeneralSearchModel {
    Patients: PatientSearchResult[];
    Orders: OrderSearchResult[];
}

export function generalSearchMapper(model: any): GeneralSearchModel {
    const result: GeneralSearchModel = { Patients: [], Orders: [] };
    model.Patients.forEach((p: any) => {
        const patient = new PatientSearchResult();
        patient.ID = p.ID;
        patient.Address = p.Address;
        patient.Age = p.Age;
        patient.CityFull = p.CityFull;
        patient.DOBShort = p.DOBShort;
        patient.DOBdmy = p.DOBdmy;
        patient.DateOfBirth = p.DateOfBirth;
        patient.DateOfDeath = p.DateOfDeath;
        patient.EmailAddress = p.EmailAddress;
        patient.FullName = p.FullName;
        patient.InternalNumber = p.InternalNumber;
        patient.Name = p.Name;
        patient.NationalNumber = p.NationalNumber;
        patient.NationalRegisterNumber = p.NationalRegisterNumber;
        patient.ReferenceNumber = p.ReferenceNumber;
        patient.Remarks = p.Remarks;
        patient.RemarksPrivate = p.RemarksPrivate;
        patient.Telephone = p.Telephone;
        patient.Temporary = p.Temporary;
        result.Patients.push(patient);
    });

    model.Orders.forEach((o: any) => {
        const order = new OrderSearchResult();
        order.ID = o.ID;
        order.Age = o.Age;
        order.DateOfBirth = o.DateOfBirth;
        order.DateTimeImplementation = o.DateTimeImplementation;
        order.FullStatus = o.FullStatus;
        order.InvoiceAmount = o.InvoiceAmount;
        order.InvoiceStatus = o.InvoiceStatus;
        order.OrderNumber = o.OrderNumber;
        order.PatientName = o.PatientName;
        order.Procedures = o.Procedures;
        order.RequestingPhysician = o.RequestingPhysician;
        order.SiteName = o.SiteName;
        order.VisitNumber = o.VisitNumber;
        result.Orders.push(order);
    });

    return result;
}
